import React from 'react';

import { FeedScreen } from '~/components/domain/posts/FeedScreen';

export default function GlobalFeed() {
  return <FeedScreen feedType="global" />;
}
